import { useLockBodyScroll } from "react-use";

export const LockBodyScroll = () => {
  useLockBodyScroll();
  return null;
};

export default useLockBodyScroll;